/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BaseHttpRequest } from "../core/BaseHttpRequest"
import type { CancelablePromise } from "../core/CancelablePromise"
import type { BenchDetectionData } from "../models/BenchDetectionData"
import type { ImageListResponse } from "../models/ImageListResponse"
import type { SegmentationData } from "../models/SegmentationData"
export class ImagesService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Serve Bench Images
   * Serve bench images from the images directory
   * @returns any Successful Response
   * @throws ApiError
   */
  public serveImageImagesFilenameGet({
    filename,
  }: {
    /**
     * Image filename
     */
    filename: string
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/images/{filename}",
      path: {
        filename: filename,
      },
      errors: {
        404: `Image not found`,
        422: `Validation Error`,
        500: `Internal server error`,
      },
    })
  }
  /**
   * Get Detection Visualization Data
   * Get detection visualization data for a specific image (segmentation and bounding boxes)
   * @returns SegmentationData Successful Response
   * @throws ApiError
   */
  public getImageSegmentationApiImageImageIdSegmentationGet({
    imageId,
  }: {
    /**
     * Image ID
     */
    imageId: number
  }): CancelablePromise<SegmentationData> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/image/{image_id}/segmentation",
      path: {
        image_id: imageId,
      },
      errors: {
        404: `Image or detection data not found`,
        422: `Validation Error`,
        500: `Internal server error`,
      },
    })
  }
  /**
   * Get Bench Images
   * Get all images for a specific bench with metadata
   * @returns ImageListResponse Successful Response
   * @throws ApiError
   */
  public getBenchImagesApiBenchBenchIdImagesGet({
    benchId,
  }: {
    /**
     * Bench ID
     */
    benchId: number
  }): CancelablePromise<ImageListResponse> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/bench/{bench_id}/images",
      path: {
        bench_id: benchId,
      },
      errors: {
        404: `Bench not found`,
        422: `Validation Error`,
        500: `Internal server error`,
      },
    })
  }
  /**
   * Get Bench Detection Data
   * Get comprehensive detection data for a specific bench including all images and detection items
   * @returns BenchDetectionData Successful Response
   * @throws ApiError
   */
  public getBenchDetectionsApiBenchBenchIdDetectionsGet({
    benchId,
  }: {
    /**
     * Bench ID
     */
    benchId: number
  }): CancelablePromise<BenchDetectionData> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/bench/{bench_id}/detections",
      path: {
        bench_id: benchId,
      },
      errors: {
        404: `Bench not found`,
        422: `Validation Error`,
        500: `Internal server error`,
      },
    })
  }
}
